const initialState = {
    stockDataPending: false,
    stockDataError:null,
    stockData:[],
    bonificationsPending: false,
    bonificationsError: false,
    bonificationsSuccess: false,
    bonificationError: false,
    bonification: {},
    isEnabledBoxAlert: true,
    backConventional: false,
    factoryDiscount: '',
    carLotDiscount: '',
    userRoles: [],
    roleBonification: {},
    roleBonificationSuccess: false, 
    roleBonificationError: false,
    roleBonificationPending: false,
    userRolesPending: false,
    userRolesError: false,
    dataFilterSelected: {},
    vin: ''
}

export default initialState
